import {
  CREATEPATIENTCARDTEMPLATE,
  GETPATIENTCARDTEMPLATE,
  DELETEPATIENTCARDTEMPLATE,
  UPDATEPATIENTCARDTEMPLATE,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETPATIENTCARDTEMPLATE:
      return {
        ...state,
        patientcardtemplateList: action.payload.data,
      };
    case UPDATEPATIENTCARDTEMPLATE:
      return {
        ...state,
        patientcardtemplateUpdateStatus: action.payload.success,
      };

    case DELETEPATIENTCARDTEMPLATE:
      return {
        ...state,
        patientcardtemplateDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
